module.exports = __webpack_public_path__ + "img/1@2x.9c3674f9.png";